import { API } from "./../../../api/config";

export const getProductsAPI = (params) => {
    return API.get("/pmbpartner/products", { params })
              .then((res) => res);
};

export const getProductByIdAPI = (params) => {
    return API.get(`/pmbpartner/products/${params.productSk}`)
              .then((res) => res);
};

export const updateProductAPI = (params) => {
    return API.put(`/pmbpartner/products/${params.productSk}`, params.body)
              .then((res) => res);
};